/** Build environment */
export const BUILD_ENV = import.meta.env.MODE;
export const APP_WEB_API_URL_PROD = 'https://cc.easproject.com';
export const APP_WEB_API_URL_DEV = 'https://cc-dev.easproject.com';

export const APP_WEB_API_URL_Q4US_PROD = 'https://manager.easproject.com/internal';
export const APP_WEB_API_URL_Q4US_DEV = 'https://internal1.easproject.com/internal';
export const APP_WEB_API_URL_Q4US_NEMAN = 'https://manager.neman.ee/internal';

export const APP_WEB_API_URL_PAY_PROD = 'https://pay.easproject.com';
export const APP_WEB_API_URL_PAY_DEV = 'https://pay-dev.easproject.com';

export const APP_WEB_API_URL_NEMAN = 'https://cc.neman.ee';

// export const IS_DEVELOPMENT = BUILD_ENV === 'development';

// export const IS_TEST = BUILD_ENV === 'test';
// export const IS_PRODUCTION = BUILD_ENV === 'production';
export const IS_PRODUCTION = window.location.origin === APP_WEB_API_URL_PROD;
export const IS_NEMAN =
	window.location.hostname === 'cc.neman.ee' || window.location.hostname === 'cc-dev.neman.ee';
export const IS_DEVELOPMENT = !IS_PRODUCTION && !IS_NEMAN;

/** Permissions */
export const ALLOW_DEV_CONSOLE = import.meta.env.VITE_ALLOW_DEV_CONSOLE === 'true';
export const ALLOW_REDUX_DEVTOOLS_EXTENSION =
	import.meta.env.VITE_ALLOW_REDUX_DEVTOOLS_EXTENSION === 'true';
export const ALLOW_WINDOW_EXTENDS = import.meta.env.VITE_ALLOW_WINDOW_EXTENDS === 'true';

/** App */
export const APP_NAME = import.meta.env.VITE_APP_NAME;
export const STORAGE_PREFIX = import.meta.env.VITE_STORAGE_PREFIX;

/** API */

// export const WEB_API_URL = IS_DEVELOPMENT
// 	? import.meta.env.VITE_WEB_API_URL
// 	: `${window.location.origin}`;

export const WEB_API_URL = IS_PRODUCTION
	? window.location.origin
	: IS_NEMAN
		? APP_WEB_API_URL_NEMAN
		: APP_WEB_API_URL_DEV;
export const WEB_API_URL_Q4US = IS_PRODUCTION
	? APP_WEB_API_URL_Q4US_PROD
	: IS_NEMAN
		? APP_WEB_API_URL_Q4US_NEMAN
		: APP_WEB_API_URL_Q4US_DEV;

/**
 * Payment gateway. One Docker image serves dev and prod, so the URL is picked by origin;
 * `VITE_PAY_API_URL_OVERRIDE` (set it only in `.env.local`, which git ignores) points a local
 * build at a locally running gateway.
 */
const PAY_API_URL_OVERRIDE = (import.meta.env.VITE_PAY_API_URL_OVERRIDE ?? '')
	.trim()
	.replace(/\/+$/, '');
export const WEB_API_URL_PAY =
	PAY_API_URL_OVERRIDE || (IS_PRODUCTION ? APP_WEB_API_URL_PAY_PROD : APP_WEB_API_URL_PAY_DEV);

/** Hangfire dashboard of the gateway (Keycloak realm `operator`, role `paymentgateway_admin`). */
export const PAYMENT_GATEWAY_HANGFIRE_URL = `${WEB_API_URL_PAY}/api/hangfire`;

export const WEB_API_URL_SHOPIFY = 'https://eu-vat-compliance.easproject.com/';
export const SHOPIFY_REMOTE_ACCESS_TOKEN = 'JSb2xlIjoiQvdrHMedtdSWRtaW4iLC';

export const PAGE_SIZE = 26;

export const EAS_VAT_REGISTRATION_NUMBER = 'GB396923051';
